import * as React from "react"

const BlockQuote = ({
  children,
  size = "small",
  lightTheme = false,
  citeLink,
  citeName,
  citeRole,
}) => {
  if (size === "large") {
    let role

    if (citeLink) {
      role = (
        <p className="blockquote__cite-company">
          <a className="text-link" href={citeLink}>
            {citeRole}
          </a>
        </p>
      )
    } else {
      role = <p className="blockquote__cite-company">{citeRole}</p>
    }

    return (
      <div className="container-fluid">
        <div className="row center-xs">
          <div className="col-xs-12 col-sm-10">
            <hr className="divider w80 mb-10" />
            <blockquote
              className={`blockquote ${lightTheme && "blockquote--light"}`}
            >
              “{children}”
            </blockquote>

            {citeName && (
              <cite>
                <p className="blockquote__cite-name">{citeName}</p>

                {citeRole && role}
              </cite>
            )}
          </div>
        </div>
      </div>
    )
  } else if (size === "small") {
    return (
      <figure>
        <blockquote className="blockquote blockquote--sm">
          “{children}”
          {citeName && (
            <figcaption className="blockquote__cite-name">
              {citeName}{" "}
              {citeRole && (
                <cite className="blockquote__cite-company">{citeRole}</cite>
              )}
            </figcaption>
          )}
        </blockquote>
      </figure>
    )
  }
}

export default BlockQuote
